export const pnrFormSchema = {
  api: {
    submit: 'pnrs',
  },
  payload: {
    includeRawFormData: true,
    // Ensure numeric fields are cast correctly
    casts: {
      formVersionNumber: 'int',
    },
    // Optional: allow-list to control payload shape strictly
    allow: [
      'actionRequiredByGovernment',
      'actionRequiredByGovernmentDesc',
      'correctiveActionCompleteDesc',
      'correctiveActionDesc',
      'deliveryScheduleRecoverable',
      'deliveryScheduleRecoverableDesc',
      'formId',
      'formVersionNumber',
      'increasedCostAnticipated',
      'increasedCostAnticipatedDesc',
      'natureSourceProblemDesc',
      'pnrNumber',
      'problemImpactDelivery',
      'problemImpactDeliveryDesc',
      'projectId',
      'rawFormData',
      'description',
      'dueDate',
    ],
  },
  blocks: [
    // Hidden read-only values fetched from forms API (not rendered)
    {
      type: 'hiddenApi',
      route: 'forms',
      // Find the PNR form record by formType
      filter: { formType: 'Problem Notification Report (PNR) Form' },
      map: {
        formId: 'formId',
        formVersionNumber: 'versionNumber',
      },
    },
    { type: 'heading', label: 'Problem Notification Report (PNR)' },
    {
      type: 'group',
      fields: [
        { type: 'text', name: 'pnrNumber', label: 'PNR Number', placeholder: 'PNR-2025-001', required: true, flex: '1 1 300px' },
        { type: 'date', name: 'dueDate', label: 'Due Date', required: false, payloadTransform: (v) => (v && v !== '') ? v : undefined, flex: '0 0 200px' },
      ],
    },
    {
      type: 'group',
      fields: [
        { type: 'text', name: 'description', label: 'Description', required: false, multiline: true, minRows: 3 },
      ],
    },
    {
      type: 'group',
      fields: [
        {
          type: 'autocomplete',
          name: 'projectId',
          label: 'Project Name',
          required: true,
          placeholder: 'Search project',
          loadFromApiRoute: 'projects',
          loadFromApiField: 'projects',
          optionLabelKey: 'title',
          optionValueKey: 'projectId',
          mapFields: { projectName: 'title' },
          helperText: 'Select a project (stores ID, displays title).'
        },
      ],
    },
    {
      type: 'group',
      fields: [
        {
          type: 'text',
          name: 'natureSourceProblemDesc',
          label: 'Nature and Source of Problem',
          required: true,
          multiline: true,
          rows: 4,
          placeholder: 'Provide a detailed description of the nature and source of the problem. Attach additional pages, if necessary.',
        },
      ],
    },
    {
      type: 'group',
      fields: [
        {
          type: 'radio',
          name: 'actionRequiredByGovernment',
          label: 'Is action required by the Government?',
          required: true,
          options: ['Yes', 'No'],
        },
        {
          type: 'text',
          name: 'actionRequiredByGovernmentDesc',
          label: 'If Yes, describe Government action required and date required',
          multiline: true,
          rows: 3,
          placeholder: 'Describe Government action required and date required.',
          condition: { field: 'actionRequiredByGovernment', value: 'Yes' },
        },
      ],
    },
    {
      type: 'group',
      fields: [
        {
          type: 'radio',
          name: 'problemImpactDelivery',
          label: 'Will the problem impact delivery schedule?',
          required: true,
          options: ['Yes', 'No'],
        },
        {
          type: 'text',
          name: 'problemImpactDeliveryDesc',
          label: 'If Yes, identify which deliverables will be affected and extent of the delay, the rationale for late delivery, and overall project impact',
          multiline: true,
          rows: 3,
          placeholder: 'Identify which deliverables will be affected and extent of the delay, the rationale for late delivery, and overall project impact.',
          condition: { field: 'problemImpactDelivery', value: 'Yes' },
        },
      ],
    },
    {
      type: 'group',
      fields: [
        {
          type: 'radio',
          name: 'deliveryScheduleRecoverable',
          label: 'Can required delivery be brought back on schedule?',
          required: true,
          options: ['Yes', 'No'],
        },
        {
          type: 'text',
          name: 'deliveryScheduleRecoverableDesc',
          label: 'Explain',
          multiline: true,
          rows: 2,
          placeholder: 'Explain',
        },
      ],
    },
    {
      type: 'group',
      fields: [
        {
          type: 'text',
          name: 'correctiveActionDesc',
          label: 'Describe corrective action needed to resolve problems',
          required: true,
          multiline: true,
          rows: 4,
          placeholder: 'Provide a detailed description of corrective action needed to resolve the problem. Attach additional pages, if necessary.',
        },
      ],
    },
    {
      type: 'group',
      fields: [
        {
          type: 'text',
          name: 'correctiveActionCompleteDesc',
          label: 'When will corrective action be completed?',
          required: true,
          multiline: true,
          rows: 3,
          placeholder: 'Provide the new delivery schedule and anticipated completion date.',
        },
      ],
    },
    {
      type: 'group',
      fields: [
        {
          type: 'radio',
          name: 'increasedCostAnticipated',
          label: 'Are increased costs anticipated?',
          required: true,
          options: ['Yes', 'No'],
        },
        {
          type: 'text',
          name: 'increasedCostAnticipatedDesc',
          label: 'If Yes, identify the amount and nature of the increased costs anticipated and define Government responsibility for problems and costs',
          multiline: true,
          rows: 3,
          placeholder: 'If Yes, identify the amount and nature of the increased costs anticipated and define Government responsibility for problems and costs.',
          condition: { field: 'increasedCostAnticipated', value: 'Yes' },
        },
      ],
    },
  ],
};
